<template>
  <div>
    <template v-for="propInput in section.properties">
      <dynamic-input-prop-data
          :key="`${propInput.id}-${dropdownControlId}`"
          :handler="handler"
          :q="q"
          :dynamic-input-prop="propInput"
          :path="completePathFor(propInput)"
          :parent-tree-context="parentTreeContext"
          @select="select"
      ></dynamic-input-prop-data>
    </template>

    <template v-for="objInput in section.objects">
      <dynamic-input-object-data
          :key="`${objInput.id}-${dropdownControlId}`"
          :handler="handler"
          :q="q"
          :dynamic-input-object="objInput"
          :path="completePathFor(objInput)"
          :parent-tree-context="parentTreeContext"
          @select="select"
      ></dynamic-input-object-data>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import DynamicInputPropData from "~/components/dynamicFieldsTrees/handlerComponents/dynamic-input-prop-data.vue";
import ProcessFlowCertificateDynamicInputsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowCertificateDynamicInputsHandler";
import ProcessFlowDynamicInputFieldsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowDynamicInputFieldsHandler";
import {IDynamicInputsConfig, IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces";
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import DynamicInput from "~/models/dynamicInput";
import CertificateDynamicInput from "../../../../formability/certificateBuilder/models/certificateDynamicInput";

export default Vue.extend({
  mixins: [handlerComponentsMixin],
  components: {
    DynamicInputPropData,
    DynamicInputObjectData: () => import("~/components/dynamicFieldsTrees/handlerComponents/dynamic-input-object-data.vue"), // async import resolves circular dependency between this component and object data component
  },
  props: {
    handler: {
      type: Object as () => ProcessFlowCertificateDynamicInputsHandler | ProcessFlowDynamicInputFieldsHandler,
      required: true,
    },
    section: {
      type: Object as () => Pick<IDynamicInputsConfig, 'properties' | 'objects' | 'select'>,
      required: true,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      default: () => {
        return [];
      },
    },
    // parentTreeContext computed by parent component for section's dynamic inputs, passed straight through this component to subcomponents
    parentTreeContext: {
      type: Object as () => IDynamicTreeContext,
      required: true,
    },
  },
  methods: {
    completePathFor(input: DynamicInput | CertificateDynamicInput): ReferencePathNode[] {
      return [
        ...this.path,
        new ReferencePathNode(null, {reference_type: input.referenceNodeType, reference_id: input.id}),
      ];
    },
  },
});
</script>